import { CheckState } from '../industryCheckReducer';

/**
 * 親が選択されている小分類idを除外する関数
 * @param {CheckState} state チェック状態のオブジェクト
 * @returns {CheckState} 親が選択されている小分類IDを除外した新しいチェック状態のオブジェクト
 */
export const removeIndustryChildIds = ({ industry, L, S }: CheckState) => {
  // 選択されている大分類に含まれるIDを除外した新しい小分類のIDのリスト
  const filteredS = S.filter(
    (sId) =>
      !industry.some(
        (lItem) =>
          L.includes(lItem.id) &&
          lItem.industrySList.some((sItem) => sItem.id === sId)
      )
  );

  return {
    industry,
    L,
    S: filteredS,
  };
};

/**
 * 親が選択されている小分類のidを追加する関数
 * @param {CheckState} state チェック状態のオブジェクト
 * @returns {CheckState} 親が選択されている小分類IDを追加した新しいチェック状態のオブジェクト
 */
export const includeIndustryChildIds = ({ industry, L, S }: CheckState) => {
  const includedS = [...S];

  // 大分類にチェックがある場合、その配下の小分類のIDを格納
  industry.forEach((lItem) => {
    if (L.includes(lItem.id)) {
      lItem.industrySList.forEach((sItem) => {
        includedS.push(sItem.id);
      });
    }
  });

  // 重複があれば排除
  const uniqueIncludedS = [...new Set(includedS)];

  return {
    industry,
    L,
    S: uniqueIncludedS,
  };
};
